const getSortByOptions = (options) => {
    if (!Array.isArray(options) || options.length === 0) {
        return [];
    }
    return options.flatMap(option => {
        var _a, _b, _c;
        const filterOption = (_a = option === null || option === void 0 ? void 0 : option.filterOption) === null || _a === void 0 ? void 0 : _a.value;
        const filterOptionLabel = (_b = option === null || option === void 0 ? void 0 : option.filterOptionLabel) === null || _b === void 0 ? void 0 : _b.value;
        const isDefaultOption = (_c = option === null || option === void 0 ? void 0 : option.isDefaultOption) === null || _c === void 0 ? void 0 : _c.value;
        if (!filterOption || !filterOptionLabel) {
            return [];
        }
        return [
            {
                label: filterOptionLabel,
                value: filterOption,
                isDefault: !!isDefaultOption,
                key: filterOption,
            },
        ];
    });
};
export default getSortByOptions;
